/**
 * THE PUBLIC DEMO'S BOOT (exception M1 in CLAUDE.md; docs/PLAN-public-demo-20261030.md) — the FIRST module
 * src/index.tsx imports, so on a demo page it runs before any other module of the app evaluates.
 *
 * Off a demo page it is one test of the address and nothing more. On one (prest0.ai/demo/<industry>/…, while the
 * build's REACT_APP_DEMO_INDUSTRIES lets that industry answer) it isolates the page from the real site and signs the
 * visitor in as the demo's Owner (./boot/isolate.ts), and opens the bare demo address on the workspace's landing — the
 * desktop, as "open your workspace" does — since the tree's own root is the marketing home page.
 */
import { demoIndustry, demoTreeBase } from './demoAddress';
import { isolateDemoPage } from './boot/isolate';

const industry = demoIndustry();
if (industry) {
  isolateDemoPage(industry);
  const base = demoTreeBase();
  const rest = window.location.pathname.slice(base.length);
  if (rest === '' || rest === '/') {
    window.history.replaceState(window.history.state, '', `${base}/desktop${window.location.search}${window.location.hash}`);
  }
}
